/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { UpdateCapacityReservationConstraintsRequest } from '../models';
/**
 * NodeTemplatesAPIApi - axios parameter creator
 * @export
 */
export const NodeTemplatesAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assigns or unassigns a capacity reservation to/from multiple node templates across clusters.
         * @summary Update capacity reservation constraints across node templates.
         * @param {string} organizationId Organization ID.
         * @param {UpdateCapacityReservationConstraintsRequest} updateCapacityReservationConstraintsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeTemplatesAPIUpdateCapacityReservationConstraints: async (organizationId: string, updateCapacityReservationConstraintsRequest: UpdateCapacityReservationConstraintsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('nodeTemplatesAPIUpdateCapacityReservationConstraints', 'organizationId', organizationId)
            // verify required parameter 'updateCapacityReservationConstraintsRequest' is not null or undefined
            assertParamExists('nodeTemplatesAPIUpdateCapacityReservationConstraints', 'updateCapacityReservationConstraintsRequest', updateCapacityReservationConstraintsRequest)
            const localVarPath = `/cluster-autoscaler/v1beta/organizations/{organizationId}/node-templates:updateCapacityReservationConstraints`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCapacityReservationConstraintsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NodeTemplatesAPIApi - functional programming interface
 * @export
 */
export const NodeTemplatesAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NodeTemplatesAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Assigns or unassigns a capacity reservation to/from multiple node templates across clusters.
         * @summary Update capacity reservation constraints across node templates.
         * @param {string} organizationId Organization ID.
         * @param {UpdateCapacityReservationConstraintsRequest} updateCapacityReservationConstraintsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nodeTemplatesAPIUpdateCapacityReservationConstraints(organizationId: string, updateCapacityReservationConstraintsRequest: UpdateCapacityReservationConstraintsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nodeTemplatesAPIUpdateCapacityReservationConstraints(organizationId, updateCapacityReservationConstraintsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeTemplatesAPIApi.nodeTemplatesAPIUpdateCapacityReservationConstraints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NodeTemplatesAPIApi - factory interface
 * @export
 */
export const NodeTemplatesAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NodeTemplatesAPIApiFp(configuration)
    return {
        /**
         * Assigns or unassigns a capacity reservation to/from multiple node templates across clusters.
         * @summary Update capacity reservation constraints across node templates.
         * @param {NodeTemplatesAPIApiNodeTemplatesAPIUpdateCapacityReservationConstraintsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nodeTemplatesAPIUpdateCapacityReservationConstraints(requestParameters: NodeTemplatesAPIApiNodeTemplatesAPIUpdateCapacityReservationConstraintsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.nodeTemplatesAPIUpdateCapacityReservationConstraints(requestParameters.organizationId, requestParameters.updateCapacityReservationConstraintsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for nodeTemplatesAPIUpdateCapacityReservationConstraints operation in NodeTemplatesAPIApi.
 * @export
 * @interface NodeTemplatesAPIApiNodeTemplatesAPIUpdateCapacityReservationConstraintsRequest
 */
export interface NodeTemplatesAPIApiNodeTemplatesAPIUpdateCapacityReservationConstraintsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof NodeTemplatesAPIApiNodeTemplatesAPIUpdateCapacityReservationConstraints
     */
    readonly organizationId: string

    /**
     * 
     * @type {UpdateCapacityReservationConstraintsRequest}
     * @memberof NodeTemplatesAPIApiNodeTemplatesAPIUpdateCapacityReservationConstraints
     */
    readonly updateCapacityReservationConstraintsRequest: UpdateCapacityReservationConstraintsRequest
}

/**
 * NodeTemplatesAPIApi - object-oriented interface
 * @export
 * @class NodeTemplatesAPIApi
 * @extends {BaseAPI}
 */
export class NodeTemplatesAPIApi extends BaseAPI {
    /**
     * Assigns or unassigns a capacity reservation to/from multiple node templates across clusters.
     * @summary Update capacity reservation constraints across node templates.
     * @param {NodeTemplatesAPIApiNodeTemplatesAPIUpdateCapacityReservationConstraintsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeTemplatesAPIApi
     */
    public nodeTemplatesAPIUpdateCapacityReservationConstraints(requestParameters: NodeTemplatesAPIApiNodeTemplatesAPIUpdateCapacityReservationConstraintsRequest, options?: RawAxiosRequestConfig) {
        return NodeTemplatesAPIApiFp(this.configuration).nodeTemplatesAPIUpdateCapacityReservationConstraints(requestParameters.organizationId, requestParameters.updateCapacityReservationConstraintsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

